import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
  type MessagePayload,
  type Messaging,
} from "firebase/messaging";
import { getFirebaseApp } from "./firebase";

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export async function isFcmSupported(): Promise<boolean> {
  try {
    return await isSupported();
  } catch {
    return false;
  }
}

let messaging: Messaging | null = null;
function getFcmMessaging(): Messaging {
  if (!messaging) messaging = getMessaging(getFirebaseApp());
  return messaging;
}

export async function requestFcmToken(
  swRegistration: ServiceWorkerRegistration
): Promise<string | null> {
  if (!(await isFcmSupported())) return null;
  if (!VAPID_KEY) throw new Error("FCM VAPID 키가 설정되지 않았습니다.");
  const token = await getToken(getFcmMessaging(), {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: swRegistration,
  });
  return token || null;
}

export function onFcmForegroundMessage(cb: (payload: MessagePayload) => void): () => void {
  return onMessage(getFcmMessaging(), cb);
}
